// Single source of truth for the site's social profiles.
// Add full profile URLs here and they are automatically injected into the
// Organization JSON-LD (sameAs) sitewide, linking the profiles to the brand.
// Example:
//   export const SOCIAL_PROFILES = [
//     'https://x.com/howbusyairport',
//     'https://www.pinterest.com/howbusyismyairport',
//     'https://www.linkedin.com/company/howbusyismyairport',
//   ];
export const SOCIAL_PROFILES = [
  'https://www.instagram.com/howbusyismyairport',
];
